import { LOADING_PAGE } from './../constants';
import { handleActions } from "redux-actions"

export const loading  = handleActions(
  {
    [ LOADING_PAGE ]: (state, action) => action.payload
  }, false
)